import React, {useEffect, useState} from 'react';
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {sanitizedMsg, transformHashtags} from "../../utils/htmlUtils";
import { replaceUrlPlaceholders} from "react-utils";
import {fromIso8601ToDdSlashMmSlashYyyy} from "../../utils/dateUtils";
import {getContributionById, getContributions} from "../../api/contributionsService";
import { hasKeycloakRole } from "../../utils/keycloakUtils";

export default function VoirContribution() {

    const navigate = useNavigate()

    const {
        id,
    } = useParams()

    const CONF = window?.confPub;
    const UI = CONF?.UI?.RECHERCHE_PERSONNE;
    const INPUTS = UI?.INPUTS;
    const ROUTES = CONF?.ROUTES;
    const PATTERNS = CONF?.PATTERNS

    // const {
    //     contributions,
    // } = useSelector(state => ({
    //     ...state.contributionReducer,
    // }))

    const {
        keycloakReduce,
    } = useSelector(state => ({
        ...state.keycloakReducer,
    }))

    // TODO ajouter conditions en fonction des dates de publication et de fin de publication

    const [contributionFromServer, setContributionFromServer] = useState([])

    useEffect(() => {

        if (id) {
            const fetchContributionById = async () => {

                try {
                    const contribution = await getContributionById(id)

                    setContributionFromServer(contribution)

                } catch (err) {

                    console.log("err", err)
                }
            }
            fetchContributionById()
        }

    }, [])

    const corps = contributionFromServer?.corps

    let corpsParse = ""

    if (corps !== undefined) {
        corpsParse = JSON?.parse(corps)
    }

    const modifierContribution = (id) => {
        const urlWithId = replaceUrlPlaceholders(ROUTES?.PAGES?.ADMIN?.MODIFIER_CONTRIBUTION, { id: id })

        navigate(urlWithId)
    }

    return (
        <main>
            <div className='container-lg mt-3'>
                <h1>{ contributionFromServer?.title }</h1>

                <div>
                    <small>
                        publié le { fromIso8601ToDdSlashMmSlashYyyy(contributionFromServer?.date) } | { contributionFromServer?.categorie } | { contributionFromServer?.sousCategorie }
                    </small>
                </div>
                <div
                    className="mt-3"
                    dangerouslySetInnerHTML={sanitizedMsg( corpsParse ? transformHashtags(corpsParse) : "Pas de corps d'article")}>
                </div>
                <div className="float-end">
                    <button
                        className="btn btn-outline-primary"
                        onClick={ () => navigate(-1) }>
                        Précédent
                    </button>
                    { hasKeycloakRole(keycloakReduce?.decodedToken, CONF?.KEYCLOAK?.ROLES?.ADMIN_FONCTIONNEL) ? (<>
                        <button className="btn btn-primary ms-2"
                            onClick={ () => modifierContribution(contributionFromServer?.id) }>
                            Modifier la contribution
                        </button>
                    </>) : '' }
                </div>
            </div>
        </main>
    )
}